const STORAGE_KEY_PREFIX = 'milora_last_active_community:';
const LAST_LEAF_KEY_PREFIX = 'milora_last_leaf:';
const PRIORITY_COMMUNITY_ID = '1rAaiFKbII';

export function getLastActiveCommunityId(userId: string): string | null {
  try {
    return localStorage.getItem(`${STORAGE_KEY_PREFIX}${userId}`);
  } catch {
    return null;
  }
}

export function setLastActiveCommunityId(userId: string, communityId: string): void {
  try {
    localStorage.setItem(`${STORAGE_KEY_PREFIX}${userId}`, communityId);
  } catch {
    // ignore storage access errors
  }
}

export function getLastLeafInGroup(userId: string, groupId: string): string | null {
  try {
    return localStorage.getItem(`${LAST_LEAF_KEY_PREFIX}${userId}:${groupId}`);
  } catch {
    return null;
  }
}

export function setLastLeafInGroup(userId: string, groupId: string, leafId: string): void {
  try {
    localStorage.setItem(`${LAST_LEAF_KEY_PREFIX}${userId}:${groupId}`, leafId);
  } catch {
    // ignore storage access errors
  }
}

/** Record last-used leaf for each ancestor group id (e.g. aggregators up the chain). */
export function recordLastLeafForAncestors(
  userId: string,
  leafId: string,
  ancestorGroupIds: string[]
): void {
  for (const groupId of ancestorGroupIds) {
    setLastLeafInGroup(userId, groupId, leafId);
  }
}

export function resolvePreferredCommunity<T extends { id: string }>(
  communities: T[],
  userId: string
): T | undefined {
  if (communities.length === 0) return undefined;

  const lastActiveId = getLastActiveCommunityId(userId);
  if (lastActiveId) {
    const match = communities.find((community) => community.id === lastActiveId);
    if (match) return match;
  }

  const priority = communities.find((community) => community.id === PRIORITY_COMMUNITY_ID);
  if (priority) return priority;

  return communities[0];
}
